{
  "phoneInvalid": "Số điện thoại không hợp lệ. Số Việt Nam nhập 0... hoặc phần số sau +84. Số nước ngoài nhập +...",
  "phoneRequired": "Vui lòng nhập số điện thoại",
  "emailInvalid": "Vui lòng nhập email hợp lệ",
  "emailRequired": "Vui lòng nhập email",
  "streetRequired": "Vui lòng nhập địa chỉ",
  "wardRequired": "Vui lòng nhập phường/xã",
  "provinceRequired": "Vui lòng nhập tỉnh/thành phố",
  "addressNotAvailable": "Chưa có địa chỉ"
}
